import axios from 'axios';
import { WeeklyProgramming } from '../types/weeklyProgramming';
import apiClient from './apiClient';

export const getTowerByIdAndBetwenData = async (projectId: number, startData: string, finishData: string): Promise<WeeklyProgramming[]> => {
  try {
    const response = await apiClient.get<WeeklyProgramming[]>(`/weeklyProgrammiing/${projectId}`, {
      params: { finishData, startData },
    });
    return response.data;
  } catch (error) {
    console.error('Error obteniendo torres por ID y fecha:', error);
    throw error;
  }
};


export const createWeeklyProgramming = async (request: WeeklyProgramming): Promise<WeeklyProgramming> => {
  try {
    const response = await apiClient.post<WeeklyProgramming>(`/weeklyProgrammiing`, request);
    return response.data;
  } catch (error) {
    console.error('Error creando programación semanal:', error);
    throw error;
  }
};

export const deleteWeeklyProgramming = async (id: number): Promise<WeeklyProgramming> => {
  try {
    const response = await apiClient.delete<WeeklyProgramming>(`/weeklyProgrammiing/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error eliminando programación semanal:', error);
    throw error;
  }
};

export const getAllWeeklyProgramming = async (): Promise<WeeklyProgramming[]> => {
  try {
    const response = await apiClient.get<WeeklyProgramming[]>(`/weeklyProgrammiing/all`);
    return response.data;
  } catch (error) {
    console.error('Error obteniendo todas las programaciones semanales:', error);
    throw error;
  }
};

export const getAllByProject = async (projectId: number): Promise<WeeklyProgramming[]> => {
  try {
    const response = await apiClient.get<WeeklyProgramming[]>(`/weeklyProgrammiing/${projectId}/all`);
    return response.data;
  } catch (error) {
    console.error('Error obteniendo programaciones por proyecto:', error);
    throw error;
  }
};


  export const exportWeeklyProgramming = async (projectId: number, startDate: string, endDate: string) => {
    try {
      const response = await apiClient.get(
        `/weeklyProgrammiing/toExel/${projectId}`, 
        {
          params: {
            startData: startDate,
            finishData: endDate,
          },
          responseType: "blob", 
        }
      );
  
      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Programacion-Semanal.xlsx"); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
    } catch (error) {
      console.error("Error al exportar la programación semanal:", error);
      throw error;
    }
  };